"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const ProjectIssueComment_1 = require("./ProjectIssueComment");
class ProjectIssue {
    constructor({ id, name, comments }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            comments: this.comments.toJSON(),
        });
        this.id = id;
        this.name = name;
        this.comments = comments;
    }
}
ProjectIssue.fromJSON = (json) => {
    const { id, name, comments } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    return new ProjectIssue({
        id,
        name,
        comments: immutable_1.List(comments).map(comment => ProjectIssueComment_1.default.fromJSON(comment)),
    });
};
exports.default = ProjectIssue;
